<template>
	<div class="alert-sub-title-container flex-row flex-align-center display-flex">
		<IntegrationIcon class="alert-app-icon" :integrationName="icon" :integrationType="iconType" :size="20" v-if="icon && !hideIcon" />
		<div class="alert-sub-title">{{ text }}</div>
		<div @click.prevent="onSubTitleLinkClick" v-if="linkText" class="alert-sub-title-link">
			{{ linkText }}
		</div>
	</div>
</template>

<script>
export default {
	name: 'SubTitle',
	props: {
		text: { type: String },
		icon: { type: String },
		linkText: { type: String },
		hideIcon: { type: Boolean },
		iconType: { type: String, default: null },
	},
	methods: {
		onSubTitleLinkClick() {
			this.$emit('subtitle-link-click');
		},
	},
};
</script>

<style scoped lang="scss">
.alert-sub-title-container {
	margin-top: 6px;

	.alert-app-icon {
		width: 21px;
		height: 21px;
		margin-right: 9px !important;
	}

	.tool-icon {
		border-radius: 4px;
		border: 1px solid #d3dae9;
		background-color: var(--bg-color);
		::v-deep svg {
			top: 50%;
			left: 50%;
			position: absolute;
			transform: translate(-50%, -50%);
		}
	}
	.alert-sub-title {
		font-size: 12px;
		text-align: left;
		color: var(--secondary-font-color);
	}

	.alert-sub-title-link {
		font-size: 12px;
		color: #5b8af7;
		text-align: left;
		padding-left: 6px;
		text-decoration: underline;
	}
}
</style>
